module.exports = __webpack_public_path__ + "img/i_youtube.12a996c2.svg";